<template>
    <v-card elevation="6" :loading="isLoadingObjetivos">
        <div class="d-flex justify-space-between align-center">
            <v-card-title
                ><h3 class="font-weight-light">Tabla Llave</h3></v-card-title
            >
            <v-btn
                depressed
                class="mx-6"
                :color="checkLlave && !checkSomeZero ? 'success' : 'error'"
            >
                {{ checkLlave && !checkSomeZero ? 1 : 0 }}
            </v-btn>
        </div>

        <v-divider class="test"></v-divider>
        <v-simple-table v-if="!isLoadingObjetivos">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th
                            class="text-left"
                            v-if="hasTeamObjectives && hasManagerPermission"
                        >
                            Nombre
                        </th>
                        <th class="text-center">Porcentaje</th>
                        <th class="text-center">Tipo</th>
                        <th class="text-center">Llave</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="objetivo in objetivosConLlave"
                        :key="objetivo.id"
                        class="text-center"
                    >
                        <td
                            class="text-left"
                            v-if="hasTeamObjectives && hasManagerPermission"
                        >
                            {{ objetivo.comercial.nombre_completo }}
                        </td>
                        <td>{{ objetivo.objetivo_porc }} %</td>
                        <td class="text-left">{{ objetivo.familia.nombre }}</td>
                        <td class="text-left">
                            {{ objetivo.objetivo_porc >= 100 ? 1 : 0 }}
                        </td>
                    </tr>
                    <tr class="text-center" v-if="thereAreObjetives">
                        <td class="text-center">No tener ningún 0</td>
                        <td></td>
                        <td class="text-left">
                            {{ checkSomeZero ? 0 : 1 }}
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <div
            v-else
            class="d-flex justify-center py-4"
            style="width: 100% !important"
        >
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
    </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'TablaLlave',
    data: () => ({}),
    computed: {
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        ...mapState('areaPersonal/calculadora', {
            objetivo: (state) => state.objetivo,
            llave: (state) => state.llave,
            isLoadingObjetivos: (state) => state.isLoadingObjetivos,
            objetivoComercial: (state) => state.objetivoComercial,
            selectedComercial: (state) => state.selectedComercial,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
        ...mapGetters('areaPersonal/calculadora', {
            objetivosConLlave: 'objetivosConLlave',
            checkLlave: 'checkLlave',
            checkSomeZero: 'checkSomeZero',
            thereAreObjetives: 'thereAreObjetives',
            hasTeamObjectives: 'hasTeamObjectives',
        }),
    },
};
</script>
